export default __webpack_public_path__ + "static/media/l3-p1.14dedaff.png";